import {
  Component,
  Input,
  SimpleChanges,
  ViewChild,
  ElementRef,
  OnChanges,
  AfterViewInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import * as $ from 'jquery';
declare let MediumEditor: any;

@Component({
  selector: 'medium-editor-shared',
  templateUrl: './medium-editor-shared.component.html',
  styleUrls: ['./medium-editor-shared.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MediumEditorSharedComponent implements OnChanges, AfterViewInit {
  @ViewChild('medEditElRef') medEditElRef: ElementRef;
  @Input() innerHTMLText = 'Enter Page Text';
  @Input() location = '';

  currentMedEditorElement: any;

  private _medEditOptions = {
    autoLink: true,
    targetBlank: true,
    buttonLabels: 'fontawesome',
    forcePlainText: false,
    cleanPastedHTML: true,
    // https://github.com/yabwe/medium-editor/issues/1422
    toolbar: {
      static: true,
      sticky: true,
      buttons: [
        'h1',
        'h2',
        'h3',
        'anchor',
        'quote',
        'bold',
        'italic',
        'underline',
        'justifyLeft',
        'justifyCenter',
        'justifyRight',
        'justifyFull',
      ],
      diffLeft: 0,
      diffTop: 10,
    },
    placeholder: {
      text: 'Enter Page Text',
      hideOnClick: true,
    },
  };

  //#region LIFECYCLE HOOKS
  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      this._setValuesFromOnChanges(changes);
    }
  }

  ngAfterViewInit(): void {
    this._setMediumEditor();
  }

  //#endregion

  getInnerText() {
    return $('.web-link-text')[0].innerHTML;
  }

  //#region PRIVATE METHODS
  private _setMediumEditor(): void {
    const element = this.medEditElRef.nativeElement;
    this.currentMedEditorElement = new MediumEditor(element, this._medEditOptions);
  }

  private _setValuesFromOnChanges(changes): void {
    this.innerHTMLText = changes.innerHTMLText.currentValue;
    if (changes.location?.currentValue) {
      this.location = changes.location.currentValue;
    }
  }
  //#endregion
}
